export const HOST = process.env.REACT_APP_HOST_API;
export const VERSION = 'api/v1/';

const APP_URL = {
    VALIDATEFORM: `${HOST}${VERSION}web/contrato/getContratoCompleto`,
    SAVEFORM: `${HOST}${VERSION}web/contrato/guardarFirmaUsuario`,
    EXPORTARCONTRATO: `${HOST}${VERSION}web/contrato/descargarContrato`,
}

export default APP_URL
